export default "__VITE_ASSET__Dpb6i5Lz__"